module.exports = {
  HOST: 'https://staging.evaluerate.de/app/api',
  IS_PROD: false,
  IS_CRS: false,
  VERSION: '1.0.3',
  language: 'de',
  TABLE_SHRINK_HEIGHT: 0
}



// WEBPACK FOOTER //
// ./src/config.js